import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '#environments';
import { Control, ControlCreateUpdate } from '#models';

@Injectable({
  providedIn: 'root',
})
export class ControlService {
  private _httpClient = inject(HttpClient);

  getControls(businessUnitId: number): Observable<Control[]> {
    return this._httpClient.get<Control[]>(`${environment.apiUrl}/businessunits/${businessUnitId}/controls`);
  }

  getControlsByFilter(params: { businessUnitId?: number; categoryId?: number }): Observable<Control[]> {
    let httpParams = new HttpParams();
    if (params.businessUnitId !== undefined) {
      httpParams = httpParams.set('businessUnitId', params.businessUnitId.toString());
    }
    if (params.categoryId !== undefined) {
      httpParams = httpParams.set('categoryId', params.categoryId.toString());
    }
    return this._httpClient.get<Control[]>(`${environment.apiUrl}/controls/filter`, { params: httpParams });
  }

  addControl(businessUnitId: number, control: ControlCreateUpdate): Observable<Control> {
    return this._httpClient.post<Control>(`${environment.apiUrl}/businessunits/${businessUnitId}/controls`, control);
  }

  updateControl(controlId: number, control: ControlCreateUpdate): Observable<Control> {
    return this._httpClient.put<Control>(`${environment.apiUrl}/controls/${controlId}`, control);
  }

  deleteControl(controlId: number): Observable<void> {
    return this._httpClient.delete<void>(`${environment.apiUrl}/controls/${controlId}`);
  }

  changeControlOrder(
    item1: Pick<Control, 'id' | 'sortId'>,
    item2: Pick<Control, 'id' | 'sortId'>
  ): Observable<Control[]> {
    return this._httpClient.put<Control[]>(`${environment.apiUrl}/controls/order`, { item1, item2 });
  }
}
